import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {
  Router
} from '@angular/router';
import { AuthStore } from '@core/services/auth/auth.store';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  private readonly authStore = inject(AuthStore);
  private readonly router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): boolean | UrlTree {
    const requiredRole = route.data['requiredRole'];
    const requiredRoles = route.data['roles'];

    const rolesToCheck: string[] = [];
    if (requiredRole) {
      rolesToCheck.push(requiredRole);
    }
    if (requiredRoles && Array.isArray(requiredRoles)) {
      rolesToCheck.push(...requiredRoles);
    }

    if (rolesToCheck.length === 0) {
      console.warn('RoleGuard: No required role specified for route');
      return this.router.createUrlTree(['/']);
    }

    const user = this.authStore.user();
    if (user && rolesToCheck.some(role => user.hasRole(role))) {
      return true;
    }
    return this.router.createUrlTree(['/']);
  }
}
